import * as env from "lib/env"
import * as idp from "lib/idp"

interface RequestOptions<TRequest> {
    method?: "GET" | "POST" | "PUT" | "PATCH"
    data?: TRequest
    headers?: Record<string, unknown>
}

export async function request<TResponse = void, TRequest = undefined>(
    resource: string,
    { method, data, headers }: RequestOptions<TRequest> = { method: "GET" }
): Promise<TResponse> {
    const accessToken = idp.getToken()

    const response = await fetch(`${env.ONBOARDING_API_URL}${resource}`, {
        method,
        body: data ? JSON.stringify(data) : undefined,
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/vnd.api+json",
            ...headers,
        },
    })

    if (response.ok) {
        return response.status == 204 ? undefined : response.json()
    }

    /**
     * server error contains useful error message like validation error, so retain the error here and pass it to the error in swr hook
     * ex: put request fails with 400 status code as below
     * {"errors":{"status":400,"title":"Bad Request","code":4300,"detail":": We could not verify your routing number. Please check your entry and try again."}}
     */
    const json = await response.json()
    if (json.errors || json.error) {
        throw json
    }

    throw new Error(`Onboarding API request failed - ${response.status}`)
}